module.exports = __webpack_public_path__ + "img/design.bfd3d277.gif";